<template lang="pug">
  .syncNewPage
    .row
        .col 
            h5(v-if="!selectedCase").bolder Select Sync Type
            //- h5(v-if="selectedCase").bolder Fill form data
    .loader-container(v-if="loading")
        img(src="@/assets/imgs/loader-spinner.svg").my-2.loader-img
    //- Show use case if nothing selected
    .cases(v-if="!selectedCase && syncTypeList")
      .row.mt-5
        .col-md-4.pr-0.tableHead FROM
          hr
        .col-md-4.pl-0.tableHead TO
          hr
        .col-md-4.tableHead USE CASE
      SyncUseCase(v-for="syncType in syncTypeList" v-bind:key="syncType.id" v-on:click="selectedUseCase(syncType.id)" :syncType="syncType")

    //- Show edit view if sync is selected
    .sync(v-if="selectedCase && sync")
      SyncUseCaseSlim(:syncType="sync").mt-3
      SyncEdit(:sync="sync" @submit-data="saveSync").mt-5
      //- button(v-if="selectedCase", @click="saveSync()").custom-btn.float-right.mt-4 Save settings
</template>

<script>
import {SyncUseCase, SyncUseCaseSlim, SyncEdit} from './SyncComponents'
import SYNC_TYPES from '../../graphql/SyncTypes.gql'
import SYNC from '../../graphql/Sync.gql'
import CREATE_UPDATE_SYNC from '../../graphql/CreateUpdateSync.gql'
import {APIManager} from '../../helpers'
export default {
  name: 'SyncNewPage',
  props:{
    selectedCase: String
  },
  components: {
    SyncUseCase, 
    SyncEdit,
    SyncUseCaseSlim
  },
  data() {
    return {
        title: "Select Sync Type",
        syncTypeList: [],
        sync: null,
        error: null,
        loading: true
    }
  },
  mounted() {
    if(this.selectedCase){
      this.getSync();
    } else {
      this.getSyncTypes()
    }
  },
  methods: {
      getSync(){
        this.$apollo.query({
          // Query
          query: SYNC,
          variables: {
            syncTypeId: this.selectedCase
          }
        })
        .then(
          (response) => {
            this.sync = APIManager.prepareData(response.data.smartsyncSync)
            this.loading = false
          }, (error) => {
            console.log(error)
            this.error = "An error occoured during processing your request."  
            this.loading = false
          })
      },
      getSyncTypes() {
        this.$apollo.query({
          // Query
          query: SYNC_TYPES
        })
        .then(
          (response) => {
            this.syncTypeList = APIManager.prepareData(response.data.smartsyncSyncTypesList, false)
            this.loading = false
          }, (error) => {
            console.log(error)
            this.error = "An error occoured during processing your request."  
            this.loading = false
          })
      },
      selectedUseCase(id){
        window.location.href = "/syncs/new/"+id
      },
      saveSync(){
        const syncToSave = APIManager.prepareSyncForSaving(this.sync)
        this.$apollo.mutate({
          // Query
          mutation: CREATE_UPDATE_SYNC,
          // Parameters
          variables: {
            input: {
              syncInput: syncToSave
            },
          }
        }).then(
          (success) => {
            console.log(success)
            window.location.href="/"
          },
          (error) => {
            console.log(error)
            this.$toasted.show("There was an error during Sync Saving", {
                type: "error",
                duration: 3000,
                className: "customAlert",
                containerClass: "customAlertContainer",
                action : {
                  text : 'Close',
                  onClick : (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              },
            }) 
          }
        )
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import url('@/less/global.less');
.custom-btn, .custom-btn:hover {
    padding: 10px;
    color:white;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 5px;
    background-color: @primary;
    a, a:hover {
      color: white !important;
      font-weight: bold;
      text-decoration: none;
    }
  }

  .tableHead {
    font-size: 12px;
    font-weight: 600;
    color: grey
  }
</style>
